/* eslint no-extra-boolean-cast: 'off', yoda: 'off',  no-prototype-builtins: 'off' */
import $ from 'jquery'

var keyCodes = {
    Tab: 9,
    Enter: 13,
    Space: 32,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40
};

var formatNumber = function (number, decimalPlaces) {
    if (number === null)
        return '.';
    if (isNaN(number)) {
        return number;
    }
    var absNumber = 0;
    var integerPortion = String(parseInt(absNumber = Math.abs(Number(number) || 0).toFixed(decimalPlaces)));
    var lengthBeforeComma = integerPortion.length;
    lengthBeforeComma = lengthBeforeComma > 3 ? lengthBeforeComma % 3 : 0;

    return (number < 0 ? '-' : '')
        + (lengthBeforeComma ? integerPortion.substr(0, lengthBeforeComma) + ',' : '')
        + integerPortion.substr(lengthBeforeComma).replace(/(\d{3})(?=\d)/g, '$1' + ',')
        + (decimalPlaces ? '.'
            + Math.abs(absNumber - integerPortion).toFixed(decimalPlaces).slice(2) : '');
};

export default {
    createButton,
    forFirst,
    getCtKeyFromControls,
    getCtKey,
    safeGet,
    safeCall,
    keyCodes,
    formatNumber,
    shallowClone,
    initialize: () => {
        $('.include-file')
            .each(function () {
                var $element = $(this);
                var includeFilePath = $element.data('include-file');
                $element.load(includeFilePath);
            })
    },
    find: function (list, doesMatchFunction) {
        for (let i = 0; i < list.length; ++i) {
            const matches = doesMatchFunction(list[i]);
            if (matches)
                return list[i];
        }
        return null;
    },
    parseFloat: function (n) {
        const results = parseFloat(n);
        return !isNaN(results) && isFinite(n) ? results : null;
    },
    isNumeric: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n)
    },
    parsePositiveInt: function (value) {
        if (this.isNumeric(value))
            return Number(value)
        else
            return null
    },
    distinct: function (items, keyName) {
        const used = {};
        return items.filter(l => {
            var key = l[keyName];
            const alreadyHave = !Boolean(used[key]);
            used[key] = true;
            return alreadyHave;
        });
    },
    groupBy: function (items, keyName, subKeyName) {
        var theObject = items.reduce(function (results, item) {
            var key = subKeyName === undefined || subKeyName === null ? item[keyName] : item[keyName][subKeyName];
            (results[key] = results[key] || []).push(item);
            return results;
        }, {});

        var results = [];
        for (var key in theObject) {
            results.push(theObject[key])
        };
        return results;
    },
    hasAll: function (hasValues, requiredValues) {
        var vm = this;
        var hasAll = true;
        requiredValues.forEach((v, i) => {
            if (hasValues.indexOf(v) < 0)
                hasAll = false;
        });
        return hasAll;
    },
    getStringIndexInArray: function (value, values) {
        for (var j = 0; j < values.length; j++) {
            if (values[j].match(value)) return j;
        }
        return -1;
    },
    getAsNumber: function (value) {
        return isNaN(value) ? value : Number(value);
    },
    methods: {
    },
    getRange: function (value) {
        var workingValue = value.replace(/ /g, '');
        if (workingValue[0] !== '(' || workingValue[workingValue.length - 1] !== ')' || workingValue.length < 4)
            return null;
        workingValue = workingValue.substring(1, workingValue.length - 1);
        var range = workingValue.split('-');
        if (range.length !== 2 || isNaN(range[0]) || isNaN(range[1]))
            return null;
        else
            return range;
    },
    formatNumberWithMinimum: function (num, decimalPlaces, isBelowMinimum) {
        if (num === null)
            return '.';
        return isBelowMinimum ? '<0.0001' : formatNumber(num, decimalPlaces);
    },
    formatNumberNoCommas: function (number, decimalPlaces) {
        if (number === null)
            return '.';
        if (isNaN(number)) {
            return number;
        }
        var absNumber = 0;
        var integerPortion = String(parseInt(absNumber = Math.abs(Number(number) || 0).toFixed(decimalPlaces)));
        return (number < 0 ? '-' : '') + integerPortion
            + (decimalPlaces ? '.'
                + Math.abs(absNumber - integerPortion).toFixed(decimalPlaces).slice(2) : '');
    },
    
    // navigateCheckboxes2: function (e, items, itemIndex) {
    // },
    navigateCheckboxes: function (e, items, itemIndex) {
        var vm = this;
        var nextIndex = 0;
        if (e.keyCode === keyCodes.ArrowRight || e.keyCode === keyCodes.ArrowDown) {
            nextIndex = ++itemIndex;
            if (nextIndex >= items.length)
                nextIndex = 0;
            items[nextIndex].focus();
            e.preventDefault();
        }

        if (e.keyCode === keyCodes.ArrowLeft || e.keyCode === keyCodes.ArrowUp) {
            nextIndex = --itemIndex;
            if (nextIndex < 0)
                nextIndex = items.length - 1;
            items[nextIndex].focus();
            e.preventDefault();
        }
    }
}
function shallowClone(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = obj[i];
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

function safeGet(theObject, theName, the2ndName, theDefault) {
    return theObject ? theObject[theName] : theDefault;
}

function safeCall(theObject, theName, theDefault) {
    return theObject ? theObject[theName]() : theDefault;
}

function getCtKeyFromControls(control1, control2) {
    const i1 = control1 && control1.control1Level ? control1.control1Level.id : 0;
    const i2 = control2 && control2.control2Level ? control2.control2Level.id : 0;
    return getCtKey(i1, i2);
}

function getCtKey(i1, i2) {
    if (i1 === 0 && i2 === 0) return null;
    if (i2 === 0) return `k_${i1}_0`;
    else return `k_${i1}_${i2}`;
}

//Find the first occurrence, execute doThis and quit.  return whether satisfied or not
function forFirst(list, where, doThis) {
    for (var i = 0; i < list.length; ++i) {
        if (where(list[i], i, list)) {
            if (doThis)
                doThis(list[i], i, list);
            return true;
        }
    }
    return false;
}

function createButton(h, onClick, caption, theClass) {

    const results = h(
        "button",
        {
            class: `hyperlink-button ${theClass || ''}`,
            type: "button",
            on: {
                click: onClick
            }
        },
        caption
    );
    return results;
}